import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ActivityComponent from './activity';
import ActivityActions from '../actions/activity';
import { useInView } from 'react-intersection-observer';

const ActivityFeed = ({ activities, currentUser, communityId, perPage = 15 }) => {

  const [fetching,     setFetching]   = useState(false);
  const [fetchedAll,   setFetchedAll] = useState(false);
  const [activityRows, setActivities] = useState(activities);

  const { ref, inView } = useInView({
    rootMargin: '3000px'
  });

  useEffect(() => {
    handleThresholdIntersection();
  }, [inView]);

  const appendActivities = newActivities => {
    setActivities([...activityRows, ...newActivities]);
  }

  const fetchMoreActivities = () => {
    if (fetching || fetchedAll) { return; }

    const before = activityRows[activityRows.length - 1].cursor;

    setFetching(true);
    ActivityActions.fetchActivities(communityId, before)
      .then(data => data.data)
      .then(data => {
        try {
          const { activities } = data;

          appendActivities(activities);

          if (activities.length < perPage) {
            setFetchedAll(true);
          }
        } catch (e) {
        } finally {
          setFetching(false);
        }
      });
  }

  const handleThresholdIntersection = () => {
    if (inView && !fetchedAll) { fetchMoreActivities(); }
  }

  const statusMessage = () => {
    if (activityRows.length === 0) {
      return (
        <div className="alert-messages">
          <div className="col-sm-8 col-sm-offset-2">
            <p className="t3 mb-30">
              No posts yet in this community
            </p>
          </div>
        </div>
      );
    }
  }

  const status = statusMessage();
  const rows = [];

  activityRows.sort((a, b) => (new Date(b.createdAt) - new Date(a.createdAt))).forEach(activity => {
    rows.push(<ActivityComponent
      key={ activity.id }
      currentUser={ currentUser }
      activity={ activity } />);
  });

  return (
    <section className="activity-list">
      { status ? status : rows }
      <div ref={ ref }></div>
    </section>
  );
}

ActivityFeed.propTypes = {
  activities: PropTypes.array.isRequired,
};

export default ActivityFeed;
